import { useAuth0 } from '@auth0/auth0-react';
import { FAST_API_URL } from 'src/config';
import axios, { AxiosRequestConfig } from 'axios';
import { useCurrentOrgContext } from 'src/contexts/OrgContext';

export function useAxios<Output, Data = undefined, Params = undefined>({
  endpoint,
  method,
  url = FAST_API_URL,
  requiresAuth = true,
}: {
  endpoint: string;
  method: 'get' | 'post' | 'put' | 'patch' | 'delete';
  url?: string;
  requiresAuth?: boolean;
}) {
  const { orgId } = useCurrentOrgContext();

  const { getAccessTokenSilently: getToken } = useAuth0();

  const fetchData = async ({
    data,
    resourceId,
    params,
  }: {
    data?: Data;
    resourceId?: string;
    params?: Params;
  }): Promise<Output> => {
    try {
      const token = requiresAuth ? await getToken() : '';

      type Headers = {
        Authorization?: string;
        'Content-Type': string;
        'x-org-id'?: string;
        'lr-session-url'?: string;
      };

      const headers: Headers = {
        Authorization: token ? `Bearer ${token}` : undefined,
        'Content-Type': 'application/json',
        'x-org-id': orgId,
      };

      let formattedUrl = url + endpoint;
      if (resourceId) formattedUrl += '/' + resourceId;

      const req: AxiosRequestConfig = {
        method: method,
        url: formattedUrl,
        headers: headers,
      };

      if (data) req.data = data;
      if (params) req.params = params;

      const response = axios(req).then((res) => res.data);

      return response;
    } catch (error) {
      throw new Error(error);
    }
  };

  return fetchData;
}
